var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "tag-container" },
      [
        _c(
          "v-btn",
          {
            staticClass: "ml-2",
            attrs: { small: "", outlined: "" },
            on: { click: _vm.togglePopup },
          },
          [
            _c("v-icon", { attrs: { left: "", small: "" } }, [
              _vm._v("mdi-label"),
            ]),
            _vm._v(" " + _vm._s(_vm.$t("settingsLivechat.tags.title")) + " "),
          ],
          1
        ),
        _vm.popupVisible
          ? _c(
              "div",
              { staticClass: "popup" },
              [
                _c(
                  "v-list",
                  { staticClass: "popup-tags", attrs: { dense: "" } },
                  _vm._l(_vm.filteredTags, function (tag, index) {
                    return _c(
                      "v-list-item",
                      {
                        key: index,
                        on: {
                          click: function ($event) {
                            return _vm.addTag(tag)
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-tag"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [_vm._v(_vm._s(tag.name))]),
                            _c("v-list-item-subtitle", [
                              _vm._v(_vm._s(tag.description)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
                _c("v-divider"),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filterText,
                      expression: "filterText",
                    },
                  ],
                  staticClass: "tag-filter pa-2",
                  attrs: { placeholder: _vm.$t("common.search") },
                  domProps: { value: _vm.filterText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.filterText = $event.target.value
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "selected-tags" },
          _vm._l(_vm.selectedTags, function (tag, index) {
            return _c(
              "v-chip",
              {
                key: index,
                staticClass: "ma-1",
                attrs: { label: "", small: "", close: "" },
                on: {
                  "click:close": function ($event) {
                    return _vm.removeTag(index)
                  },
                },
              },
              [_vm._v(" " + _vm._s(tag) + " ")]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }